import API from '../../../../../services/api';

export const API_SCRAPPING = {
    scrappingURL: async (url) => {
        return API.post('/scrapping', {url: url.url}).then(res => res.data);
    },
    completePartInfoScraper: async (part) => {
        return API.post('/scrappingByRef', {part: part}).then(res => res.data);
    }
}